import React from 'react';
import clsx from 'clsx';

import scss from './StoryBadge.module.scss';

function StoryBadge({ icon: Icon, label, className, size = 'md' }) {
  if (!label) {
    return null;
  }

  return (
    <span className={clsx(scss.badge, scss[size], className)}>
      {Icon ? <Icon className={scss.icon} /> : null}
      <span className={scss.label}>{label}</span>
    </span>
  );
}

export default StoryBadge;
